import { jsx as _jsx } from "react/jsx-runtime";
import { Container, Stack } from 'xen-ui';
export const Page = ({ children, 'data-testid': dataTestId, gap = 'md', ...props }) => {
    return (_jsx(Container, { "data-testid": dataTestId, p: { base: 'sm', xs: 'xl' }, ...props, children: _jsx(Stack, { gap: gap, children: children }) }));
};
